import React from "react";
import moment from "moment";

import Preloader from "components/app/Preloader";
import AvailableProductsHomeSections from "components/app/home/AvailableProductsHomeSections";

import "./HomePage.css";

export default class HomePage extends React.Component {
  
  getGreeting() {
    const now = moment();
    const morningCutoff = moment(now).hour(12).startOf("hour");
    const afternoonCutoff = moment(now).hour(18).startOf("hour");
    if (now.isBefore(morningCutoff)) {
      return "Good Morning!";
    }
    if (now.isBefore(afternoonCutoff)) {
      return "Good Afternoon!";
    }
    return "Good Evening!";
  }
  
  render() {
    return (
      <div className="home-page">
        <h1 className="home-greeting">{ this.getGreeting() }</h1>
        <div className="home-page-sections">
          <Preloader>
            <AvailableProductsHomeSections />
          </Preloader>
        </div>
      </div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/components/app/home/HomePage.js